import React from 'react';

const AWS_Machine_Learning = () => {
  return (
    <div>
      <h1>AWS_Machine_Learning</h1>
      <p>This is the AWS_Machine_Learning component.</p>
    </div>
  );
};

export default AWS_Machine_Learning;
